<template>
   <div class="hotel-basket-container">
      <div class="hotel-basket-wrapper">
         <div class="hotel-basket-inner">
            <div class="hotel-basket-inner-wrapper">
               <!-- Hotel Basket Title Wrapper -->
               <div class="hotel-basket-title-wrapper">
                  <div class="hotel-basket-title-top">
                     <span class="hotel-basket-title"> </span>
                  </div>
                  <div class="hotel-basket-title-bottom">
                     <div class="hotel-stars">
                        <i v-for="(item, index) in this.$store.state.hotel.basketResponse.hotelStar" :key="'activeStar-' + index" class="gts-icon icon-star active"></i>
                        <i v-for="(item, index) in 5 - this.$store.state.hotel.basketResponse.hotelStar" :key="'star' + index" class="gts-icon icon-star"></i>
                     </div>
                     <span class="hotel-basket-delete" @click="clearBasket">
                        <i class="gts-icon icon-hotel-empty-basket icon-sm"></i>
                     </span>
                  </div>
               </div>

               <div class="dotted-line"></div>

               <div class="hotel-basket-content">
                  <div class="basket-list">
                     <div class="basket-list-item" v-for="(basketRoomItem, index) in basket.rooms" :key="index">
                        <div class="basket-room-name">
                           <span>{{ basketRoomItem.roomName }}</span>

                           <span class="hotel-basket-boardName-txt">{{ basket.boardName }}</span>
                        </div>
                        <div class="basket-room-price-info">
                           <div class="basket-room-price-info-item room-price">
                              <span>{{ $t("hotelBasket_lblRoomPrice") }}</span>
                              <span>{{ basketRoomItem.rate | price(basketRoomItem?.currency) }}</span>
                           </div>
                        </div>
                        <div class="basket-addon-wrapper" v-if="basketRoomItem.addOns.length != 0">
                           <span class="addon-section-title">
                              {{ $t("hotelCard_lblhasAddonTitle") }}
                           </span>
                           <div class="basket-addon-inner-wrapper" v-for="(addOn, addOnIndex) in basketRoomItem.addOns" :key="addOnIndex">
                              <span class="addon-title">
                                 {{ addOn.title }}
                              </span>
                              <div class="addon-infos">
                                 <span class="addon-date">{{ addOn.effectiveDate | FormatterDate }}</span>
                                 <span class="addon-price">{{ addOn.price | price(addOn?.currency) }}</span>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="hotel-basket-cta" v-if="basket.checkoutEnabled" @click="handlerCheckout(basket.basketUuid)">
                  <button>
                     <!-- <i class="gts-icon icon-arrow-full icon-sm"></i> -->
                     <p class="total-container">
                        <span class="total-text">{{ $t("basketComponentFlight_total") }}</span>
                        <span class="total-price"> {{ basket.totalPrice | price(basket?.rooms[0]?.currency) }}</span>
                     </p>
                  </button>

                  <UIButton
                     className="light"
                     :text="`${basket.totalPrice} ${basket.totalPriceCurrency}`"
                     isRouter="true"
                     v-if="false"
                     :routerUrl="{
                        name: 'HotelCheckout',
                        params: { uuid: basket.uuid },
                     }"
                     z
                     target="_blank" />
               </div>
               <div class="send-offer" :class="$store.state.app.clientInformations.isMobile ? '--mobile' : ''" @click="handlerDocumentViewer(7)">
                  {{ $t("basketComponentHotel_sendOffer") }}
               </div>
               <div class="hotel-basket-cta-mobile d-flex flex-row justify-content-end">
                  <div class="hotel-basket-cta-mobil-close d-lg-none" @click="handlerCloseBasket">
                     <UIButton className="default_outline" :text="$t('basketComponentFlight_closeBasket')" />
                  </div>
                  <div class="hotel-basket-cta-mobil d-xxl-none" v-if="basket.checkoutEnabled" @click="handlerCheckout(basket.basketUuid)">
                     <UIButton className="default" :text="$t('basketComponentFlight_goToCheckout')" />
                  </div>
               </div>
            </div>
         </div>
      </div>

      <PaxConnectButton :offerSuccess="offerSuccess" :showSubtitle="true" @click="handlerCreateOffer" />
   </div>
</template>

<script>
import { hotelService } from "@/service/index.js";
import { handleCreateOffer } from "@/helper/offerHelper.js";
import Popup from "@/gts-popup.js";

import UIButton from "@/components/unitary/Button.vue";
import PaxConnectButton from "@/components/common/PaxConnectButton.vue";

export default {
   name: "HotelBasketComponent",
   components: {
      UIButton,
      PaxConnectButton,
   },
   data() {
      return {
         offerLoading: false,
         offerSuccess: false,
         selectQuery: {
            searchUuid: this.$store.state.hotel.searchUuid,
            hotelId: this.$store.state.hotel.basketResponse.hotelCode,
            rooms: this.$store.state.hotel.selectedRooms,
            recommended: this.$store.state.hotel.basketResponse.recommended,
         },
         basketResponse: "",
      };
   },
   computed: {
      basket() {
         return this.$store.state.hotel.basketResponse;
      },
   },
   mounted() {
      console.log(this.basket);
   },
   methods: {
      handlerDocumentViewer(type) {
         const self = this;
         self.offerLoading = true;
         this.$store.state.app.documentViewer.request.documentType = type;
         this.$store.state.app.documentViewer.request.identifiers = [{ identifier: self.selectQuery.searchUuid, subIdentifiers: [self.basket.basketUuid] }];
         this.$store.state.app.documentViewer.request.fileType = 2;
         this.$store.state.app.documentViewer.request.showPrice = false;
         this.$store.state.app.documentViewer.hasPrice = true;
         self.$store.state.app.documentViewer.activeProductStatus = 0;
         this.$store.commit("app/setDocumentViewer", true);
      },
      handlerCloseBasket() {
         this.$parent.$parent._data.isBasketActive = false;
      },
      handlerCheckout(basketUuid) {
         window.open(`/hotel/checkout/${this.selectQuery.searchUuid}/${basketUuid}`);
      },

      handlerCreateOffer() {
         handleCreateOffer({
            basketUuid: this.basket.basketUuid,
            entityType: 3, // HOTEL
            pageSource: 1, // BASKET
            $store: this.$store,
            $i18n: this.$i18n,
            onSuccess: () => {
               this.offerSuccess = true;
               setTimeout(() => {
                  this.offerSuccess = false;
               }, 5000);
            },
         });
      },

      clearBasket() {
         const self = this;

         self.selectQuery.rooms = {};
         this.$store.state.hotel.basketResponse.hotelCode = null;
         this.$store.state.hotel.selectedRooms = {};

         hotelService.hotelSelect(self.selectQuery).then((response) => {
            if (!response.result.success) {
               Popup.result(response.result);
               return;
            } else {
               self.basketResponse = {
                  hotelCode: 0,
                  id: response.id,
                  basketUuid: response.basketUuid,
                  rooms: response.rooms,
                  totalPrice: response.totalPrice.total,
                  totalPriceCurrency: this.$options.filters.currency(response.totalPrice.currency),
                  uuid: response.uuid,
                  checkoutEnabled: response.checkoutEnabled,
                  recommended: response.recommended,
                  channelId: Object.keys(response.rooms).length === 0 ? 0 : response.channelId,
                  boardId: Object.keys(response.rooms).length === 0 ? 0 : response.boardId,
                  hotelName: Object.keys(response.rooms).length === 0 ? 0 : response.hotelName,
                  boardName: Object.keys(response.rooms).length === 0 ? 0 : response.board,
                  hotelStar: Object.keys(response.rooms).length === 0 ? 0 : response.hotelStar,
               };
               this.$store.commit("hotel/updateBasketResponse", self.basketResponse);
            }
         });
      },
   },
};
</script>

<style lang="scss" scoped>
.hotel-basket-container {
   display: flex;
   flex-direction: column;
   align-items: center;
   gap: 1rem;
   position: sticky;
   top: 1rem;
   height: fit-content;
   width: 100%;
}

.hotel-basket-wrapper {
   display: flex;
   flex-direction: column;
   background-color: var(--basket-bg);
   width: 100%;
   border-radius: 0.5rem;

   .hotel-basket-inner {
      display: flex;
      border-radius: 8px;
      width: 100%;

      .hotel-basket-inner-wrapper {
         padding: 1.5rem 1rem;
         width: 100%;

         .hotel-basket-title-wrapper {
            .hotel-basket-title-top {
               display: flex;
               justify-content: space-between;
               align-items: center;
               font-size: var(--normal);
               font-weight: 600;
               //color: var(--gray-50);
               color: var(--gray-0);
            }

            .hotel-basket-title-bottom {
               display: flex;
               align-items: center;
               justify-content: space-between;
               .hotel-stars {
                  display: flex;
                  i {
                     width: 12px !important;
                     margin-right: 4px;
                     opacity: 0.3;

                     &:last-child {
                        margin-right: 0;
                     }
                  }
                  i.active {
                     opacity: 1;
                     filter: invert(74%) sepia(100%) saturate(805%) hue-rotate(358deg) brightness(103%) contrast(103%);
                  }
               }

               i {
                  cursor: pointer;
                  transform: scale(1);
                  transition-property: transform;
                  transition-timing-function: ease-in-out;
                  transition-duration: 0.1s;

                  &:hover {
                     transform: scale(1.15);
                  }
               }

               .hotel-basket-delete {
               }
            }
         }

         .dotted-line {
            background-image: linear-gradient(to right, var(--gray-200) 33%, var(--gray-0-alpha-90) 0%);
            background-position: left;
            background-size: 12px auto;
            background-repeat: repeat-x;
            display: inline-block;
            width: 100%;
            bottom: 7px;
            left: 1rem;
            right: 1rem;
            height: 2px;
         }
         .hotel-basket-content {
            .basket-list {
               margin-top: 1rem;
               .basket-list-item {
                  padding-bottom: 1rem;
                  margin-bottom: 1rem;
                  border-bottom: 1px dashed var(--gray-0-alpha-75);
                  .basket-room-name {
                     span {
                        color: var(--txt-white);
                        font-size: var(--normal);
                        font-weight: 500;
                     }

                     .hotel-basket-boardName-txt {
                        display: flex;
                        color: var(--basket-teal);
                        font-size: var(--small);
                     }
                  }

                  .basket-room-price-info {
                     .basket-room-price-info-item {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        span {
                           &:first-child {
                              color: var(--txt-white);
                              font-size: var(--small);
                           }
                           &:last-child {
                              color: var(--basket-teal);
                              font-size: var(--large);
                              font-weight: 800;
                           }
                        }
                     }
                  }

                  &:last-child {
                     border-bottom: none !important;
                  }
                  .basket-addon-wrapper {
                     margin-top: 1rem;
                     background-color: rgba(0, 0, 0, 0.3);
                     border-radius: 0.75rem;
                     padding: 1rem;

                     .addon-section-title {
                        display: block;
                        //color: var(--gray-50);
                        color: var(--txt-white);
                        font-weight: 600;
                        border-bottom: 1.5px dotted rgba(255, 255, 255, 0.5);
                        padding-bottom: 0.25rem;
                        margin-bottom: 0.25rem;
                     }
                     .basket-addon-inner-wrapper {
                        .addon-title {
                           //color: var(--gray-50);
                           color: var(--txt-white);
                        }
                        .addon-infos {
                           display: flex;
                           flex-direction: column;
                           justify-content: space-between;
                           align-items: baseline;
                           .addon-date {
                              color: var(--basket-teal);
                              font-weight: 500;
                              font-size: var(--small);
                           }
                           .addon-price {
                              color: var(--basket-teal);
                              font-size: 1.25rem;
                              font-weight: 600;
                           }
                        }
                     }
                  }
               }
            }
         }
         .hotel-basket-cta {
            button {
               padding: 0.5rem 1.5rem;
               border-radius: 12rem;
               width: 100%;
               margin: 1rem 0;
               /* box-shadow: var(--gray-500-alpha-50) 0px 2px 8px 0px; */
               box-shadow: var(--gts-box-shadow);
               display: flex;
               align-items: center;
               justify-content: center;
               border: 2px solid var(--blue-800);
               transition: all 0.2s ease-in-out;

               i {
                  position: relative;
                  left: -0.5rem;
                  margin-right: 0.5rem;
                  transition: all 0.2s ease-in-out;
                  filter: invert(19%) sepia(28%) saturate(5280%) hue-rotate(204deg) brightness(70%) contrast(85%);
               }

               p.total-container {
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  position: relative;
                  top: 0;
                  transition-property: top;
                  transition-timing-function: ease-in-out;
                  transition-duration: 0.2s;
                  .total-text {
                     color: var(--blue-800);
                     font-size: var(--xsmall);
                     font-weight: 600;
                     transition: opacity, 0.2s, ease-in-out;
                     opacity: 1;
                  }
                  .total-price {
                     font-size: 1.25rem;
                     font-weight: 800;
                     color: var(--blue-800);
                  }
               }
            }
            &:hover {
               button {
                  background-color: var(--blue-900);
                  border: 2px solid var(--blue-800);

                  i {
                     left: -0.1rem;
                     filter: invert(100%) sepia(100%) saturate(10) hue-rotate(160deg) brightness(100%) contrast(200%);
                  }
               }
               p.total-container {
                  top: -10px;
                  .total-text {
                     color: var(--blue-800);
                     font-size: var(--xsmall);
                     font-weight: 600;

                     opacity: 0;
                  }
                  .total-price {
                     color: var(--basket-teal);
                  }
               }
            }
         }
         .send-offer {
            color: var(--txt-white);
            text-align: center;
            width: 100%;
            display: block;
            text-decoration: underline;
            font-size: var(--small);
            cursor: pointer;
            &.--mobile {
               color: var(--primary);
               font-size: var(--large);
               text-align: start;
            }

            &:hover {
               color: var(--basket-teal);
            }
         }
      }

      .hotel-basket-inner-wrapper2 {
         width: 100%;
         .hotel-basket-title {
            display: inline-flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            border-bottom: 1px solid var(--blue-600);
            padding-bottom: 16px;
            margin-bottom: 24px;
            & > span {
               &.title {
                  margin-bottom: 0;
                  color: white;
                  font-size: 24px;
               }
               &.cta-button {
                  display: inline-flex;
                  align-items: center;

                  border-radius: 16px;
                  padding: 8px 16px;
                  padding-right: 0.125rem !important;
                  font-size: 12px;
                  cursor: pointer;
               }
            }
         }
         .hotel-basket-content {
            margin-bottom: 24px;
            .basket-list {
               .basket-list-item {
                  padding-bottom: 16px;
                  margin-bottom: 16px;
                  border-bottom: 1px dotted var(--blue-600);

                  &:last-child {
                     margin-bottom: 0;
                  }
                  .basket-room-name {
                     margin-bottom: 16px;
                     & > span {
                     }
                  }
                  .basket-room-price-info {
                     .basket-room-price-info-item {
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                        margin-bottom: 8px;

                        &:last-child {
                           margin-bottom: 0;
                        }

                        & > span {
                           font-size: 12px;
                        }

                        &.room-price {
                        }
                        &.room-count {
                        }
                     }
                  }
               }
            }
         }
         .hotel-basket-cta {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            ::v-deep a {
               width: 100%;
               font-size: 24px;

               & > span {
                  width: 100%;
               }
            }
         }
      }
   }
}
</style>
<style lang="scss" scoped>
@media (max-width: 1350px) {
   .hotel-basket-wrapper {
      position: fixed;
      z-index: 101;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100%;
      border-radius: 0;
      //background-color: var(--gray-50);
      background-color: var(--gray-0);

      .hotel-basket-title {
         color: var(--gray-700);
         font-size: var(--xxlarge);
      }

      .hotel-stars {
         transform: scale(1.5);
         transform-origin: left top;
      }

      .hotel-basket-content {
         background: var(--gray-100);
         border-radius: 0.5rem;
         margin: 1rem 0;
         padding: 1rem;

         .basket-room-name {
            span {
               font-size: var(--large) !important;
               color: var(--gray-700) !important;
               &.hotel-basket-boardName-txt {
                  font-size: var(--large) !important;
               }
            }
         }

         .basket-room-price-info {
            .basket-room-price-info-item {
               span {
                  color: var(--primary) !important;
                  &:first-child {
                     font-size: var(--large) !important;
                  }
                  &:last-child {
                     font-size: var(--large) !important;
                  }
               }
            }
         }
      }

      .basket-list-item {
         border-bottom: 1px dashed var(--gray-600-alpha-75) !important;
      }

      .hotel-basket-delete {
         position: absolute;
         right: 1rem;
         top: 2.5rem;
         transform: scale(1.5);

         i {
            filter: brightness(0.25);
         }
      }

      .hotel-basket-cta {
         display: none;
      }
      .hotel-basket-cta-mobil {
         display: flex;
         justify-content: flex-end;
      }
      .hotel-basket-cta-mobil-close {
         display: flex;
         justify-content: flex-end;
         margin-right: 0.5rem;
      }
   }
}
</style>

<style lang="scss">
.offer-button {
   width: fit-content;
   width: 200px;
   min-height: 50px;
   padding: 0.5rem;
   background-color: #fe6501;
   outline: 4px solid #fe9818;
   border: none;
   border-radius: 10rem;
   cursor: pointer;
   display: flex;
   align-items: center;
   justify-content: center;
   transition: all 0.3s ease;
   gap: 0.75rem;

   &:hover {
      transform: scale(1.05);
   }

   &.offer-success {
      background-color: #10b981;
      outline: 4px solid #34d399;
   }

   .offer-button-content {
      display: flex;
      flex-direction: column;
      line-height: 1.125rem;
      // align-items: center;
      // gap: 0.25rem;

      .offer-title {
         font-size: var(--normal);
         font-weight: 800;
         color: white;
         text-align: left;
      }

      .offer-subtitle {
         font-size: var(--xsmall);
         color: white;
         opacity: 0.9;
      }
   }
}
</style>
